import React from 'react'

import { connect } from 'react-redux'
import { Add_Division } from '../../../../../../Store/Actions/Setting.Action'

import { TextField, Button, CircularProgress } from '@mui/material'


class SettingDivisionAdd extends React.Component {
    state = {
        Nama: '',
        isNamaError: false,
        Deskripsi: ''
    }
    onChangeField = (e) => {
        this.setState({ [e.target.name]: e.target.value })
    }
    changeToError = (e, value) => {
        this.setState({ isNamaError: value })
    }
    formOnSubmit = (e) => {
        e.preventDefault()
        this.props.Add_Division(this.state.Nama, this.state.Deskripsi)
    }
    render() {
        const {
            Nama,
            isNamaError,
            Deskripsi,
        } = this.state

        const isDivisionActionAddLoading = this.props.isDivisionActionAddLoading
        const isDivisionExist = this.props.isDivisionExist

        return (

            <form
                onSubmit={this.formOnSubmit}
            >
                <div
                    style={{ margin: '0 5% 0 5%' }}
                >
                    <TextField
                        label='Nama'
                        type='text'
                        name='Nama'
                        value={Nama}
                        required
                        onInvalid={(e) => this.changeToError(e, true)}
                        onChange={this.onChangeField}
                        style={{ width: '100%', margin: '1% 0 1% 0' }}
                        error={isDivisionExist || isNamaError ? true : false}
                        helperText={isDivisionExist ? 'Division Sudah Ada' : isNamaError ? 'Nama Harus diisi' : ''}
                    />
                    <TextField
                        label='Deskripsi'
                        type='text'
                        name='Deskripsi'
                        value={Deskripsi}
                        onChange={this.onChangeField}
                        style={{ width: '100%', margin: '1% 0 1% 0' }}
                    />
                </div>
                <center>
                    <Button
                        variant='contained'
                        size='large'
                        style={{ border: '0px solid red', width: "85%", margin: '3% 0 2% 0' }}
                        type='submit'
                        disabled={isDivisionActionAddLoading ? true : false}
                    >
                        {isDivisionActionAddLoading ? <CircularProgress /> : 'Add Division'}
                    </Button>
                </center>
            </form>
        )
    }
}

const mapStateToProps = state => ({
    isDivisionActionAddLoading: state.Setting.isDivisionActionAddLoading,
    isDivisionExist: state.Setting.isDivisionExist,
})

export default connect(mapStateToProps, { Add_Division })(SettingDivisionAdd)